import React from "react";
import { DetailedPaymentPrefUnionObjectType } from "../../common/types";
import { PaymentPrefDisplayCardContainer } from "../PaymentPrefDisplayCardContainer";
import { getPaymentMethodIconType } from "../PaymentPrefDisplayCardContainer/utils";
import { PreviewPaymentPrefDisplay } from "../PreviewPaymentPrefDisplay";

export type PreviewPaymentPrefDisplayCardProps = {
  /** Payment preference data to preview */
  paymentPref: DetailedPaymentPrefUnionObjectType;
};

/**
 * Card component for previewing payment preference information.
 *
 * This component wraps PreviewPaymentPrefDisplay in a card container with an icon.
 * For advanced features like accessory content, field visibility configuration,
 * and default expanded state, use PreviewPaymentPrefDisplay directly.
 *
 * @example
 * ```tsx
 * // Basic preview card
 * <PreviewPaymentPrefDisplayCard
 *   paymentPref={newPaymentPref}
 * />
 * ```
 */
export const PreviewPaymentPrefDisplayCard: React.FC<PreviewPaymentPrefDisplayCardProps> = ({
  paymentPref,
}: PreviewPaymentPrefDisplayCardProps) => {
  const iconType = getPaymentMethodIconType(paymentPref);

  return (
    <PaymentPrefDisplayCardContainer iconType={iconType}>
      <PreviewPaymentPrefDisplay paymentPref={paymentPref} />
    </PaymentPrefDisplayCardContainer>
  );
};
